import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=3939bb55&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=3939bb55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3939bb55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3939bb55')) {
      api.createRecord('3939bb55', component.options)
    } else {
      api.reload('3939bb55', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=3939bb55&scoped=true&", function () {
      api.rerender('3939bb55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/landing/Landing.vue"
export default component.exports